import { FC } from 'react';
import { Button, HStack, Icon } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

const BottomBarBasketActions: FC = () => {
  const { t } = useTranslation();

  return (
    <HStack spacing="4">
      <Button
        isDisabled
        variant="secondary"
        onClick={() => console.info('Basket action clicked!')}
        leftIcon={<Icon name="GeneralActionsRefreshOrReload" />}
      >
        {t('Re-calculate')}
      </Button>
      <Button
        isDisabled
        onClick={() => console.info('Basket action clicked!')}
        rightIcon={<Icon name="GeneralActionsArrowRight" />}
      >
        {t('FINISH')}
      </Button>
    </HStack>
  );
};

export default BottomBarBasketActions;
